import {validateRequired, validateRequiredIfNot} from "./ValidationFunctions";

const createFormConfig = {
  fields: {
    name: {
      type: 'text',
      label: 'Form name',
      rules: [validateRequired('Form name')]
    },
    type: {
      type: 'formType',
      label: 'Choose form type',
      placeholder: 'New Form type',
      rules: [validateRequiredIfNot('Form type', 'type_new')]
    },
    type_new: {
      type: 'text',
      placeholder: 'Or Create new form type',
      label: 'or create new form type',
      rules: [validateRequiredIfNot('Form type', 'type'), {
        feedback: 'Form type must contain only lowercase letters and numbers, max 20 chars',
        test(value) {
          return !value ? true : /^[a-z0-9]{1,20}$/.test(value)
        }
      }]
    },
    scale: {
      type: 'select',
      label: 'Rating maximum',
      options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    riskAlert: {
      type: 'select',
      label: 'Risk Alert',
      options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  }
};

const editFormNameConfig = {
  fields: {
    name: {
      type: 'text',
      label: 'Form name',
      rules: [validateRequired('Form name')]
    },
    scale: {
      type: 'select',
      label: 'Rating maximum',
      options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    riskAlert: {
      type: 'select',
      label: 'Risk Alert',
      options: ['disabled', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    requireAckComment: {
      type: 'boolean',
      label: 'Require acknowledgement comment',
    }
  }
};

export {
  createFormConfig,
  editFormNameConfig
}
